import React from "react";
import { Mail, BookOpen, FileText, Home, GitBranch, ExternalLink } from "lucide-react";

const Help = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 text-center">
      {/* Header */}
      <h1 className="text-3xl font-bold mb-6">EHR-QC: Help</h1>

      {/* GitLab Source */}
      <div className="mb-6">
        <a
          href="https://gitlab.com/tyagilab/ehr-qc-2.0"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-blue-600 hover:underline"
        >
          <GitBranch className="w-5 h-5" />
          Source Code on GitLab
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>

      {/* Description */}
      <p className="text-gray-700 mb-10">
        This website provides a web-based interface for <strong>EHR-QC</strong>,
        a comprehensive tool designed to manage electronic health record (EHR)
        data for machine learning applications. It supports a range of
        functionalities, including data standardisation, pre-processing,
        visualisation, exploration, and preparation of EHR datasets.
      </p>

      {/* Quick Links */}
      <div className="grid grid-cols-2 gap-6 mb-12">
        <div className="flex flex-col items-center">
          <Home className="w-8 h-8 text-green-600 mb-2" />
          <h3 className="font-semibold">Getting Started</h3>
          <a href="/" className="text-blue-600 hover:underline flex items-center gap-1">
            Link <ExternalLink className="w-4 h-4" />
          </a>
        </div>
        <div className="flex flex-col items-center">
          <BookOpen className="w-8 h-8 text-purple-600 mb-2" />
          <h3 className="font-semibold">Documentation</h3>
          <a href="#" className="text-blue-600 hover:underline flex items-center gap-1">
            View Docs <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Citation Section */}
      <div className="text-left">
        <h3 className="text-lg font-semibold mb-4">If you use this utility, please cite the following articles:</h3>

        <div className="mb-4">
          <p className="mb-1">
            1. Yashpal Ramakrishnaiah, Nenad Macesic, Geoffrey I. Webb, Anton Y. Peleg, Sonika Tyagi
            <em> EHR-QC - A streamlined pipeline for automated electronic health records standardisation
              and preprocessing to predict clinical outcomes</em>
          </p>
          <a
            href="https://doi.org/10.1016/j.jbi.2023.104509"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-blue-600 hover:underline"
          >
            <FileText className="w-4 h-4" /> Paper <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div>
          <p className="mb-1">
            2. Samuel Mainwood et al.
            <em> EHR-QC 2.0: Enhanced LLM-driven medical concept mapping, FHIR support, and web-based interface</em>
          </p>
          <a
            href="#"
            className="inline-flex items-center gap-1 text-blue-600 hover:underline"
          >
            <FileText className="w-4 h-4" /> Paper <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="mb-6">
        <p className="mb-1">
          <strong className="font-semibold">
            For further correspondence please contact Associate Professor Sonika Tyagi:
            <br />
            <Mail className="w-4 h-4" />
            <a href="mailto:sonika.tyagi@rmit.edu.au" className="text-blue-600 hover:underline">
              sonika.tyagi@rmit.edu.au
            </a>
            <br />
            <Mail className="w-4 h-4" />
            <a href="mailto:sonika.tyagi@monash.edu" className="text-blue-600 hover:underline">
              sonika.tyagi@monash.edu
            </a>
          </strong>
        </p>
      </div>

    </div>
  );
};

export default Help;
